import React from "react";
import { Zap, MapPin, Cpu, DollarSign } from "lucide-react";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
const advantages = [{
  title: "Location",
  description: "Safe neighborhood, friendly neighbors, plenty of parking, and very close to the bus stop.",
  icon: MapPin
}, {
  title: "Room",
  description: "Each room comes with a queen-size or full-size bed, a comfortable mattress, and clean bedding. It also includes air conditioning, a personal portable heater, and a private door lock with a unique code for each guest",
  icon: Zap
}, {
  title: "Support",
  description: "You can contact me 24/7, and I’ll respond to your questions as quickly as possible",
  icon: Cpu
}];
export default function WhyWorkGenLeadsInEssex() {
  return <section data-section-id="86831" id="why-stay-with-us" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4 text-primary">Our Difference</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-light">
            Experience the perfect blend of professional hospitality and the cozy comfort of a private Southern California home.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {advantages.map((adv, i) => <Card key={i} data-index={i} className="group relative overflow-hidden bg-transparent border-none transition-all duration-500 hover:bg-white hover:-translate-y-1 hover:shadow-xl rounded-xl">
              <div className="absolute bottom-0 left-0 w-full h-[2px] bg-transparent group-hover:bg-chart-2 transition-colors duration-500" />
              
              <CardHeader className="pb-4 flex flex-col items-center text-center">
                <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center mb-6 group-hover:bg-secondary/80 transition-colors duration-500">
                  <adv.icon className="w-7 h-7 text-primary transition-colors duration-500" />
                </div>
                <h3 className="text-[22px] font-serif font-medium leading-tight text-primary transition-colors duration-500">
                  {adv.title}
                </h3>
              </CardHeader>
              
              <CardContent className="text-center">
                <p className="text-muted-foreground font-light leading-relaxed transition-colors duration-500">
                  {adv.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}